import { useLanguage } from "@/context/LanguageContext";

export const LangToggle = ({ testid }) => {
    const { lang, toggleLang } = useLanguage();
    return (
        <button
            onClick={toggleLang}
            data-testid={testid}
            aria-label="Toggle language"
            className="flex items-center gap-1 px-3 py-2 font-mono text-[10px] uppercase tracking-[0.22em] border border-white/15 hover:border-fw/60 text-white transition-colors rounded-sm"
        >
            <span className={lang === "it" ? "text-fw font-medium" : "text-white/40"}>IT</span>
            <span className="text-white/30">/</span>
            <span className={lang === "en" ? "text-fw font-medium" : "text-white/40"}>EN</span>
        </button>
    );
};
